import { useHistory } from 'react-router-dom'
import { MainPanel } from '@calendly/booking-kit'
import { TitleText, BodyText } from '@calendly/ui/components/typography'
import { FlexLayout } from '@calendly/ui/components/flex-layout'

import Wrapper from 'components/wrapper'
import Container from 'components/layout/container'
import { useI18n } from 'locales'
import { getTotalSessionCount } from 'utils'

import { RepurchasePageContainer, Body, StyledButton } from './styles'

const RepurchasePackagePage = ({ purchasedPackage, eventType }) => {
  const { i18n } = useI18n()
  const history = useHistory()

  const sessionCount = getTotalSessionCount(purchasedPackage.purchased_package_items)
  const packageName = purchasedPackage.name
  const hostName = eventType?.profile?.name || eventType?.owning_user?.name
  const profileSlug = eventType?.profile?.slug
  const packageUuid = purchasedPackage.package_uuid

  const handlePurchaseAgain = () => {
    history.push(`/${profileSlug}/packages/${packageUuid}`)
  }

  return (
    <Wrapper>
      <Container>
        <MainPanel>
          <RepurchasePageContainer>
            <FlexLayout direction="column" gap={16}>
              <TitleText level={2} as="h1" size="large">
                {i18n.t('booking.repurchase_package.title')}
              </TitleText>
              <Body>
                <BodyText>
                  {i18n.t('booking.repurchase_package.message', {
                    count: sessionCount,
                    package_name: packageName,
                    host_name: hostName
                  })}
                </BodyText>
                <StyledButton
                  decoration="primary"
                  onClick={handlePurchaseAgain}
                >
                  {i18n.t('booking.repurchase_package.purchase_button')}
                </StyledButton>
              </Body>
            </FlexLayout>
          </RepurchasePageContainer>
        </MainPanel>
      </Container>
    </Wrapper>
  )
}

export default RepurchasePackagePage
